import api from 'Application/api/api';

const getAvailableModules = (cancelToken = null) =>
    api.get('/companies/current/available-modules', { cancelToken });

export default getAvailableModules;
